'use strict';

import { render } from 'react-dom';
import AuthPanel from './AuthPanel.jsx';

export default function($) {
	const $footer_container = $('#navbar--footer-container');
	const $footer = $('#navbar--footer');
	
	$footer_container.css({
		position: 'fixed',
		width: 1,
		height: 1,
		left: '-200%',
	});
	
	$footer.addClass('top-0 h-full w-full fixed')
		.css({
			transition: 'opacity .5s ease-out, left .25s ease-out',
			left: '-100%',
			opacity: 0,
			'-webkit-overflow-scrolling': 'touch',
		});
	
	$('#navbar--mobile-menu-button')
		.click(e => {
			e.preventDefault();
			$footer.css({ left: 0, opacity: 1 });
		});
	
	$('#navbar--mobile-close-button')
		.removeClass('hidden')
		.click(e => {
			e.preventDefault();
			$footer.css({ left: '-100%', opacity: 0 });
		});
	
	const csrf = $('meta[name=csrf-token]').attr('content');
	
	function isValidContainer(node) {
		return !! (node && node.nodeType === 1);
	}
	
	window.InterNACHI.session.onGuest(() => {
		const footer_top = document.getElementById('navbar--footer-top');
		if (isValidContainer(footer_top)) {
			render(<AuthPanel loading={ false } user={ null } admin_content={ null } csrf={ csrf } current_url={ window.location.href } />, footer_top);
		}
	});
	
	window.InterNACHI.session.onLoaded(() => {
		const footer_top = document.getElementById('navbar--footer-top');
		const admin_content = $('#navbar--admin-content').html();
		if (isValidContainer(footer_top)) {
			render(<AuthPanel loading={ false } user={ window.logged_in_user } admin_content={ admin_content } csrf={ csrf } current_url={ window.location.href } />, footer_top);
		}
	});
}
